if (!window.Eurus.loadedScript.has('sku-description.js')) {
  window.Eurus.loadedScript.add('sku-description.js');

  requestAnimationFrame(() => {
    const registeredSections = new Set();

    const normalizeSku = (sku) => {
      if (!sku) return '';
      return sku.toString().trim().toUpperCase();
    };

    const parseSelectedVariant = (scope) => {
      const selectedVariantEl = scope?.querySelector('.variant-selects-main script[type="application/json"][data-selected-variant]');
      if (!selectedVariantEl) return null;

      try {
        return JSON.parse(selectedVariantEl.textContent);
      } catch (error) {
        return null;
      }
    };

    const updateSkuDescription = (sku) => {
      const skuNo = normalizeSku(sku);
      console.log('skuNo', skuNo);
      let descriptionContainer = document.getElementsByClassName('custom-sku-description');
      if (descriptionContainer.length > 0) {
        let skuDivs = descriptionContainer[0].querySelectorAll('div[class^="sku-"]');
        skuDivs.forEach(div => div.style.display = 'none');
        console.log('skuDivs', skuDivs);
        let targetDiv = descriptionContainer[0].querySelector('div.sku-' + skuNo);
        targetDiv.style.display = '';
      }
    };

    const defaultVariant = parseSelectedVariant(document);

    setTimeout(function (){
        updateSkuDescription(defaultVariant?.sku),
        1000
    });
  });
}
